export default __webpack_public_path__ + "static/media/ministerio-02.f737659e.svg";